import { getShowConfirmationPage } from '../../../selectors/tools';
import { useSelector } from 'react-redux';
import DTReplaceSelectedItemsNode from '../NodeGroups/DTSelectedItemTransaction/Nodes/DTReplaceSelectedItemsNode/DTReplaceSelectedItemsNode';

const ReplaceSelectedItemsThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTReplaceSelectedItemsNode showConfirmation={showConfirmationPage} message={'The items have been replaced.'} />
  );
};

export default ReplaceSelectedItemsThenSendMacro;
